import "@src/styles/index.css";
import { App } from "@src/app/components/App";
import type { MessageKey } from "@src/i18n/locale-catalog";
import { getLocaleFromLanguageTag } from "@src/i18n/locale-catalog";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { translate } from "@src/i18n/translate";

const root = document.querySelector<HTMLDivElement>("#app");
if (!root) throw new Error("Missing #app root");

const locale = getLocaleFromLanguageTag(document.documentElement.lang);
const t = (key: MessageKey, values?: Record<string, string | number>) =>
  translate(locale, key, values);

createRoot(root).render(
  <StrictMode>
    <App locale={locale} t={t} version={__MATTRIZ_APP_VERSION__} />
  </StrictMode>,
);
